<template>
  <div class="docusign-container">
    <span class="text--l text--bold">DocuSign</span>
    <div class="spacer--m" />
    <span class="text--m text--bold">{{config.title}}</span>
    <div class="spacer--m" />
    <span class="text--m">{{config.description}}</span>
    <div class="spacer--m" />
    <a-btn
      outlined
      :disabled="!config.webFormUrl"
      :append-icon="require('@/assets/icons/link-mdi.svg')"
      @click="initDocuSign"
    >Continue to DocuSign</a-btn>
    <transition name="slide-y-transition" mode="out-in">
      <div v-if="showDocuSignModal" class="docusign-modal">
        <img src="~@/assets/icons/exit.svg" alt="close" class="exit-btn" @click="closeDocuSignModal" />
        <div v-if="docuSignLoading" class="docusign-loading-container">
          <LoadingIndicator />
        </div>
        <iframe
          v-show="!docuSignLoading"
          :src="docuSignLink"
          @load="iframeLoaded"
          class="iframe"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import ABtn from "@/components/SelfService/a-btn.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";

export default {
  name: 'SelfServeDocuSign',
  components: {LoadingIndicator, ABtn},
  props: {
    config: {
      type: Object,
      default() { return {} },
      required: true
    }
  },
  data() {
    return {
      showDocuSignModal: false,
      docuSignLoading: false
    }
  },
  methods: {
    initDocuSign() {
      const url = this.config.webFormUrl;

      if (!url) return;

      if (this.useNewTab) {
        this.openLinkInNewTab(url);
      } else {
        this.showDocuSignModal = true;
        this.docuSignLoading = true;
      }
    },
    iframeLoaded() {
      this.docuSignLoading = false;
    },
    closeDocuSignModal() {
      this.showDocuSignModal = false;
      this.docuSignLoading = false;
    },
    openLinkInNewTab(url) {
      window.open(url, '_blank');
    }
  },
  computed: {
    docuSignLink() {
      return this.config.webFormUrl || null;
    },
    useNewTab() {
      return true; // this.config.useNewTab;
    }
  }
}
</script>

<style scoped lang="scss">
.docusign-container {
  border: solid 1px black;
  display: inline-block;
  padding: 16px;
  border-radius: 12px;
  min-width: 60%;
  //position: relative;

  .docusign-modal {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 999;
    overflow-y: auto;

    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }

    .docusign-loading-container {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .exit-btn{
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
  }
}

.slide-y-transition-enter-active, .slide-y-transition-leave-active {
  transition: transform 0.3s;
}

.slide-y-transition-enter, .slide-y-transition-leave-to {
  transform: translateY(100%);
}
.slide-y-transition-enter-to, .slide-y-transition-leave {
  transform: translateY(0);
  }
</style>
